var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg73(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "224px",
    height: "55px",
    viewBox: "0 0 224 55",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.3311 55C46.6156 55 23.6319 37.9492 0.1728 4.16344C-0.144215 3.84769 0.0142926 3.21618 0.331308 3.0583C0.648324 2.74254 1.12385 2.90042 1.44086 3.21618C25.534 37.6335 48.8347 54.5264 70.5502 53.2633C88.3031 52.3161 100.508 40.0016 113.506 27.0557C126.186 14.2676 139.343 1.00589 158.364 0.058627C179.604 -1.04652 201.478 13.4782 223.827 43.1592C224.144 43.4749 223.986 44.1065 223.669 44.2643C223.352 44.5801 222.876 44.4222 222.559 44.1065C200.527 15.057 178.97 0.848015 158.364 1.79528C139.977 2.74254 126.979 15.6885 114.615 28.3187C102.093 40.9489 89.0956 53.8949 70.7087 55C69.9162 55 69.1237 55 68.3311 55Z",
    id: "Path",
    fill: "#292929",
    fillOpacity: 0.8662807,
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg73);
export default __webpack_public_path__ + "static/media/73.98c38fd84bfcee5e345c4db4ba2e60cb.svg";
export { ForwardRef as ReactComponent };